import { useManifestViewsV2 } from "hooks/useManifestViewsV2";
import { useManifestViewsV3 } from "hooks/useManifestViewsV3";

import { Manifests } from "./Manifests";
import { Manifests as ManifestsV1 } from "./ManifestsV1";
import { ManifestsV3 } from "./ManifestsV3";

/**
 * Routes the Manifests page to the V3 mixed manifests/bills-of-lading view
 * when `manifest-views-v3` is enabled for the tenant; otherwise to the v2
 * view when `manifest-views-v2` is enabled, and to the v1 view otherwise.
 * The v3 check comes first: it does not change what v1/v2 render for a
 * tenant without its flag.
 */
export function ManifestsView() {
  const showManifestViewsV3 = useManifestViewsV3();
  const showManifestViewsV2 = useManifestViewsV2();
  if (showManifestViewsV3) return <ManifestsV3 />;
  return showManifestViewsV2 ? <Manifests /> : <ManifestsV1 />;
}
